module.exports = __webpack_public_path__ + "static/media/share_copy_link.b0313f00.svg";